export default "__VITE_ASSET__DIjeDDYL__"